// Helpers compartidos de facturación AFIP (usados por la facturación de la
// SUSCRIPCIÓN — sección "Facturación de tu plan" — y reutilizables por el POS).
// Ver docs/2026-08-02-facturacion-afip-suscripcion-spec.md.

/** Condiciones frente al IVA del receptor (define el tipo de comprobante A/B/C). */
export const CONDICIONES_IVA = [
  'Responsable Inscripto',
  'Monotributista',
  'Exento',
  'Consumidor Final',
] as const;

export type CondicionIVA = (typeof CONDICIONES_IVA)[number];

/**
 * Valida un CUIT/CUIL argentino: 11 dígitos + dígito verificador (módulo 11).
 * Acepta el string con o sin guiones/espacios.
 */
export function validarCUIT(cuit: string): boolean {
  const limpio = (cuit || '').replace(/\D/g, '');
  if (limpio.length !== 11) return false;
  const mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let suma = 0;
  for (let i = 0; i < 10; i++) suma += parseInt(limpio[i], 10) * mult[i];
  let verificador = 11 - (suma % 11);
  if (verificador === 11) verificador = 0;
  if (verificador === 10) return false; // CUIT inválido por norma
  return verificador === parseInt(limpio[10], 10);
}

/** Formatea un CUIT de 11 dígitos como 30-12345678-9 (para mostrar). */
export function formatCUIT(cuit: string): string {
  const limpio = (cuit || '').replace(/\D/g, '');
  if (limpio.length !== 11) return cuit;
  return `${limpio.slice(0, 2)}-${limpio.slice(2, 10)}-${limpio.slice(10)}`;
}
